import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { CampaignBannerItem } from './item';
import { useAtomValue } from 'jotai';
import { $CampaignBanner } from '~/models/campaign-banner';
import { DotIndicator, DotIndicatorRef } from '~/components/dot-indicator';
import { useCallback, useRef } from 'react';

import './style.scss';

export const CampaignCarousel = (): JSX.Element => {
  const campaigns = useAtomValue($CampaignBanner);

  const $indicator = useRef<DotIndicatorRef>(null);
  const $swiper = useRef<SwiperClass>();

  const handleIndicatorIndexChange = useCallback((target: number) => {
    if (!$swiper.current) {
      return;
    }

    $swiper.current.slideToLoop(target);
  }, []);

  const handleSwiperSlides = useCallback((swiper: SwiperClass) => {
    $indicator.current?.changeTo(swiper.realIndex);
  }, []);

  return (
    <div className="campaign-carousel">
      <Swiper
        slidesPerView={1}
        loop
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        onSwiper={(s) => ($swiper.current = s)}
        onSlideChange={handleSwiperSlides}
      >
        {campaigns.map((campaign) => (
          <SwiperSlide key={campaign.campaignId}>
            <CampaignBannerItem campaign={campaign} />
          </SwiperSlide>
        ))}
      </Swiper>
      {campaigns.length > 1 && (
        <DotIndicator
          ref={$indicator}
          className="campaign-indicator"
          count={campaigns.length}
          onChange={handleIndicatorIndexChange}
        />
      )}
    </div>
  );
};
